/**
 * Report & Block translations
 */

import type { TranslationDict } from '../types'

export const report: TranslationDict = {
  title: {
    en: 'Report',
    'zh-CN': '举报',
    ja: '報告',
  },
  subtitle: {
    en: 'Why are you reporting this {{targetType}}?',
    'zh-CN': '为什么要举报这个{{targetType}}？',
    ja: 'この{{targetType}}を報告する理由は？',
  },
  spam: {
    label: {
      en: 'Spam',
      'zh-CN': '垃圾信息',
      ja: 'スパム',
    },
    description: {
      en: 'Fake engagement, scams, or repetitive content',
      'zh-CN': '广告、恶意链接或重复内容',
      ja: '偽のエンゲージメント、詐欺、または繰り返しコンテンツ',
    },
  },
  harassment: {
    label: {
      en: 'Harassment',
      'zh-CN': '骚扰',
      ja: 'ハラスメント',
    },
    description: {
      en: 'Bullying, threats, or targeted abuse',
      'zh-CN': '欺凌、威胁或针对性攻击',
      ja: 'いじめ、脅迫、または標的型の攻撃',
    },
  },
  violence: {
    label: {
      en: 'Violence',
      'zh-CN': '暴力内容',
      ja: '暴力',
    },
    description: {
      en: 'Threats of violence or graphic content',
      'zh-CN': '暴力威胁或血腥内容',
      ja: '暴力の脅迫またはグラフィックコンテンツ',
    },
  },
  adult_content: {
    label: {
      en: 'Adult Content',
      'zh-CN': '成人内容',
      ja: 'アダルトコンテンツ',
    },
    description: {
      en: 'Nudity or sexual content',
      'zh-CN': '裸露或色情内容',
      ja: 'ヌードまたは性的コンテンツ',
    },
  },
  misinformation: {
    label: {
      en: 'Misinformation',
      'zh-CN': '虚假信息',
      ja: '誤情報',
    },
    description: {
      en: 'False or misleading information',
      'zh-CN': '误导性或虚假的信息',
      ja: '虚偽または誤解を招く情報',
    },
  },
  copyright: {
    label: {
      en: 'Copyright',
      'zh-CN': '侵权内容',
      ja: '著作権侵害',
    },
    description: {
      en: 'Unauthorized use of copyrighted material',
      'zh-CN': '侵犯版权或知识产权',
      ja: '著作権で保護された素材の無断使用',
    },
  },
  other: {
    label: {
      en: 'Other',
      'zh-CN': '其他',
      ja: 'その他',
    },
    description: {
      en: 'Something else not listed above',
      'zh-CN': '其他违规行为',
      ja: '上記以外の問題',
    },
  },
  description_placeholder: {
    en: 'Add details (optional)',
    'zh-CN': '补充说明（可选）',
    ja: '詳細を追加（任意）',
  },
  submit: {
    en: 'Submit Report',
    'zh-CN': '提交举报',
    ja: '報告を送信',
  },
  success: {
    en: 'Report submitted',
    'zh-CN': '举报已提交',
    ja: '報告が送信されました',
  },
  already_reported: {
    en: "You've already reported this",
    'zh-CN': '您已经举报过了',
    ja: 'すでに報告済みです',
  },
  error: {
    en: 'Failed to submit report',
    'zh-CN': '举报失败，请稍后重试',
    ja: '報告の送信に失敗しました',
  },
}

export const block: TranslationDict = {
  block: {
    en: 'Block',
    'zh-CN': '屏蔽',
    ja: 'ブロック',
  },
  confirm_title: {
    en: 'Block @{{username}}?',
    'zh-CN': '屏蔽 @{{username}}？',
    ja: '@{{username}} をブロックしますか？',
  },
  confirm_desc: {
    en: "They won't be able to follow you or view your posts.",
    'zh-CN': '对方将无法关注你或查看你的帖子。',
    ja: 'あなたをフォローしたり、投稿を見たりできなくなります。',
  },
  confirm_button: {
    en: 'Block',
    'zh-CN': '屏蔽',
    ja: 'ブロック',
  },
  success: {
    en: 'User blocked',
    'zh-CN': '已屏蔽该用户',
    ja: 'ユーザーをブロックしました',
  },
  unblock_success: {
    en: 'User unblocked',
    'zh-CN': '已取消屏蔽',
    ja: 'ブロックを解除しました',
  },
  unblock: {
    en: 'Unblock',
    'zh-CN': '取消屏蔽',
    ja: 'ブロック解除',
  },
  status_banner: {
    en: "You've blocked @{{username}}",
    'zh-CN': '你已屏蔽 @{{username}}',
    ja: '@{{username}} をブロックしています',
  },
  view_anyway: {
    en: 'View profile',
    'zh-CN': '查看主页',
    ja: 'プロフィールを見る',
  },
}
